module.exports = __webpack_public_path__ + "img/L_320_325.705a8f73.png";